import http from '@/assets/common/http';
// ---提交下单时间
export function submitOrderDate(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----查看是否已存在时间
export function queryDateFun(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询商品
export function queryProduct(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
/**
 * 添加某个产品进入购物车
 * 接口：SERVICE_ID 10175 / OTYPE 1；SUPPLIER_ID 由本函数自动注入，调用方无需传递
 * @param {Object} data 业务参数
 * @param {number} data.CART_ID 购物车内部代码
 * @param {number} data.VENDOR_ID 供货商内部代码
 * @param {number} data.PRODUCT_CODE 商品内部代码
 * @param {number} data.PRODUCT_COUNT 商品数量
 * @param {number} data.PRICE 商品价格
 * @param {number} data.TAX_RATE 税率
 * @param {number} data.BEFORE_TAX_PRICE 税前价格
 * @returns {Promise<*>} 成功时 resolve 后端返回数据；失败时 reject 错误文本
 */
export function addShoppingCart(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除某个产品进入购物车
export function deleteProduct(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询购物车详情
export function queryShopCar(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改购物车数量
export function updateCount(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改购物车产品备注
export function updateComment(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}
// 清控商品
export function cleanProduct(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 7,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 提交订单
export function placeOrder(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 5,
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取应急供应商
export function emergencySupplier(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取应急下单商品
export function getEmergencyFun(data) {
  const params = {
    SERVICE_ID: '10175',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/purchaseOrderManage.js